/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),
	$cproductGridImages: $('.template-collection .grid-link__image--product'),
    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  timber.cacheVariables();
  theme.mobileNav();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();

  
    theme.productImageGallery();
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
//     if(theme.cache.$mobileSublistTrigger.not($el).hasClass('is-active')){

//     }

    $('.mobile-nav__sublist > li a').removeClass('is-active');
    $('.mobile-nav__sublist > li a').next('.mobile-sublink-wrap').slideUp(200);

    if(theme.cache.$mobileSublistTrigger.not($el).hasClass('is-active')){
      theme.cache.$mobileSublistTrigger.not($el).removeClass('is-active');
      theme.cache.$mobileSublistTrigger.not($el).next('.mobile-nav__sublist').slideUp();
      }
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });

  $('.mobile-nav__sublist > li a').on('click',function(e){
    if($(this).hasClass('is-active')){
      $(this).removeClass('is-active');
      $(this).next('.mobile-sublink-wrap').slideUp(200);
    }else{
      $(this).addClass('is-active');
      $(this).next('.mobile-sublink-wrap').slideDown(200);
    }
  });

};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());
  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() { 
    /*theme.cache.$productGridImages.css('height', 'auto').equalHeights();*/
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
    theme.cache.$cproductGridImages.css('height', '243').equalHeights();
    
  }
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

// Initialize theme's JS on docready
$(theme.init)


$(document).ready(function(){
  $('.comment-scroll').on('click', function(){
    var pos = $("#comment_form").offset().top - 120;
    $([document.documentElement, document.body]).animate({
        scrollTop: pos
    }, 1000);
  });

  collectionRandom();
  collectionRandomOriginalArt();
  collectionRandomCuriousArt();
  collectionRandomLimitedEditionPrints();
  collectionRandomShaunTanLimitedEditionPrints();
  productRandom();
  heightImg();
  $(window).resize(function(){
    if ($('body').hasClass('template-index')) {
      $('.equalHeights__random').css('height', 'auto').equalHeights();
    } else {
      if ( window.innerWidth < 831 ) {
        $('.equalHeights__random').css('height', 'auto').equalHeights();
      } else {
        $('.equalHeights__random').css('height', 'auto');
      }
    }
    $('.equalHeights__product').css('height', 'auto').equalHeights();
    heightImg();
    sanTanThumbnail();
  });

  setInterval(()=>{
    sanTanThumbnail();
  },1500);
});

function sanTanThumbnail(){
  var divElement = document.querySelector('.grid.collection-random-shaun-tans-limited-edition-prints');
    var images = divElement.querySelectorAll('img');
    var largestHeight = 0;
    
    images.forEach(function(image) {
        if (image.height > largestHeight) {
            largestHeight = image.height;
        }
    });
    var elementsToSetHeight = document.querySelectorAll('.grid.collection-random-shaun-tans-limited-edition-prints .equalHeights__random');
    elementsToSetHeight.forEach(function(element) {
        element.style.setProperty('height', largestHeight + 'px', 'important');
    });
}

function heightImg() {
  if ($('.equalHeights-js').length > 0) {
    $('.equalHeights-js').each(function() {
      $(this).find('.equalHeights__image').css('height', 'auto').equalHeights();
    });
  }
}

function collectionRandom() {
  if ($('.collection-random').length > 0) {
    var collection = [];
    $('.collection-random li').each(function(){
      var id = $(this).data('id');
      collection.push(id);
    });
    var all_size = $('.collection-random li').length,
        limit = $('.collection-random').data('limit');
    if (all_size > limit) {
      size = limit;
    } else {
      size = all_size;
    }
    var random_index = [];
    while(random_index.length < size){
      var key = collection[Math.floor(Math.random()*collection.length)];
     
      if( random_index.indexOf(key) == -1 ) {
        random_index.push(key);
        var collectionImg = $('.collection-random li[data-id="' +key+ '"]').data('img'),
            collectionHandle = $('.collection-random li[data-id="' +key+ '"]').data('handle'),
            collectionTitle = $('.collection-random li[data-id="' +key+ '"]').data('title');
        var html = '';
        html +=  '<div class="grid__item item">';
            html +=  '<div class="equalHeights__random"><a href="/collections/' +collectionHandle+ '"><img class="lazyload test8"  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-expand="600" data-src="'+collectionImg+'" alt="'+collectionTitle+'" /></a></div>';
            html +=  '<h5><a href="/collections/' +collectionHandle+ '">'+collectionTitle+'</a></h5>';
        html +=  '</div>';
        $('.collection-random').append(html);
      }
    }
    if ($('body').hasClass('template-index')) {
      var check = setInterval(function(){
        if (random_index.length >= size) {
          $('.equalHeights__random').css('height', 'auto').equalHeights();
          clearInterval(check);
        }
      }, 300);
    } else {
      if ( window.innerWidth < 831 ) {
        var check = setInterval(function(){
          if (random_index.length >= size) {
            $('.equalHeights__random').css('height', 'auto').equalHeights();
            clearInterval(check);
          }
        }, 300);
      }
    }
  }
}

function collectionRandomOriginalArt() {

  var new_title=localStorage.getItem('title_text');
  var new_button=localStorage.getItem('button_text');
  console.log(new_button);
  if(new_title != null){
    jQuery('.collection-random-original-art').find('h2').text(new_title);
  jQuery('.sidebar').find('h2 a').text(new_title);
  }
    var $aTag = $('a[data-theme-editor-setting="section.1561002010343.button_label/escape"]');
console.log($aTag);
  if(new_button != null){
      $aTag.text(new_button);

  }


  if ($('.collection-random-original-art').length > 0) {
    var collection = [];
    $('.collection-random-original-art li').each(function(){
      var id = $(this).data('id');
      collection.push(id);
    });
    var all_size = $('.collection-random-original-art li').length,
        limit = $('.collection-random-original-art').data('limit');
    if (all_size > limit) {
      size = limit;
    } else {
      size = all_size;
    }
    var random_index = [];html = '';
       var html = '<div class="grid-uniform grid-link__container test mycollection">';
    while(random_index.length < size){
      var key = collection[Math.floor(Math.random()*collection.length)];
     console.log(key);
      if( random_index.indexOf(key) == -1 ) {
        random_index.push(key);
        var collectionImg = $('.collection-random-original-art li[data-id="' +key+ '"]').data('img'),
            collectionHandle = $('.collection-random-original-art li[data-id="' +key+ '"]').data('handle'),
            collectionTitle = $('.collection-random-original-art li[data-id="' +key+ '"]').text(),
            collectionPrice = $('.collection-random-original-art li[data-id="' +key+ '"]').data('price'),
            collectionsessionPrice = $('.collection-random-original-art li[data-id="' +key+ '"]').data('session-price');
        var $priceElement = $(collectionPrice);
        var extractedText = $priceElement.text();
            collectionavailable = $('.collection-random-original-art li[data-id="' +key+ '"]').data('available');

       html +=  '<div class="grid__item waseem wide--one-fifth large--one-quarter medium-down--one-half equalHeights__random"><a href="/collections/original-art-inventory-stockroom/products/' +collectionHandle+ '"><span class="grid-link__image grid-link__image--product" style="height: 243px;"><span class="grid-link__image-centered"><div class="second_section"><img class="test3 lazyloaded"  src="'+collectionImg+'" data-expand="600" data-src="'+collectionImg+'" alt="'+collectionTitle+'" /></div></span></span><div class="info-product">';
       html += '<p class="grid-link__title">'+collectionTitle+'</p>'
       if(collectionavailable != false){
       html += '<p class="grid-link__meta"><span class="mlmoney" style="display: inline-block;"><span class="">'+extractedText+'</span></span></p><p class="grid-link__meta custmoney">'+collectionsessionPrice+'<span class="hideaud" style="display: none;"> + GST</span></p>';
        }
        else{
          html += '<p class="grid-link__meta m-t-5"><span class="red_circle"></span></p>';
        }
	   html +=  '</div></a></div>';        
      }
    }
      html += '</div>';
    $('.collection-random-original-art').append(html);
   
    if ($('body').hasClass('template-index')) {
      var check = setInterval(function(){
        if (random_index.length >= size) {
          $('.equalHeights__random').css('height', 'auto').equalHeights();
          clearInterval(check);
        }
      }, 300);
    } else {
      if ( window.innerWidth < 831 ) {
        var check = setInterval(function(){
          if (random_index.length >= size) {
            $('.equalHeights__random').css('height', 'auto').equalHeights();
            clearInterval(check);
          }
        }, 300);
      }
    }
  }
}

function collectionRandomCuriousArt() {
  if ($('.collection-random-curious-art').length > 0) {
    var collection = [];
    $('.collection-random-curious-art li').each(function(){
      var id = $(this).data('id');
      collection.push(id);
    });
    console.log(collection);
    var all_size = $('.collection-random-curious-art li').length,
        limit = $('.collection-random-curious-art').data('limit');
    if (all_size > limit) {
      size = limit;
    } else {
      size = all_size;
    }
    var random_index = [];
    while(random_index.length < size){
      var key = collection[Math.floor(Math.random()*collection.length)];
     console.log(key);
      if( random_index.indexOf(key) == -1 ) {
        random_index.push(key);
        var collectionImg = $('.collection-random-curious-art li[data-id="' +key+ '"]').data('img'),
            collectionHandle = $('.collection-random-curious-art li[data-id="' +key+ '"]').data('handle'),
            collectionTitle = $('.collection-random-curious-art li[data-id="' +key+ '"]').data('title'),
            collectionPrice = $('.collection-random-curious-art li[data-id="' +key+ '"]').data('price');
            var $priceElement = $(collectionPrice);
            var extractedText = $priceElement.text();
            collectionsessionPrice = $('.collection-random-curious-art li[data-id="' +key+ '"]').data('session-price');
            collectionavailable = $('.collection-random-curious-art li[data-id="' +key+ '"]').data('available');
           
        
        var html = '';
        html +=  '<div class="grid__item item">';
            html +=  '<div class="equalHeights__random"><a href="/collections/gift-shop-curios-art-objects/products/' +collectionHandle+ '"><img class="lazyload test8 custom-height"  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-expand="600" data-src="'+collectionImg+'" alt="'+collectionTitle+'" /></a></div>';
            html +=  '<h5><a href="/collections/gift-shop-curios-art-objects/products/' +collectionHandle+ '">'+collectionTitle+'</a></h5>';
        if(collectionavailable != false){
          html +=  '<p class="mlmoney"><span>'+extractedText+'</span></p>';
          html += '<p class="grid-link__meta custmoney">'+collectionsessionPrice+'<span class="hideaud" style="display: none;"> + GST</span></p>';
        }
        else{
          html += '<p class="grid-link__meta m-t-5"><span class="red_circle"></span></p>';
        }
        html +=  '</div>';
        $('.collection-random-curious-art').append(html);
      }
    }
    if ($('body').hasClass('template-index')) {
      var check = setInterval(function(){
        if (random_index.length >= size) {
          $('.equalHeights__random').css('height', 'auto').equalHeights();
          clearInterval(check);
        }
      }, 300);
    } else {
      if ( window.innerWidth < 831 ) {
        var check = setInterval(function(){
          if (random_index.length >= size) {
            $('.equalHeights__random').css('height', 'auto').equalHeights();
            clearInterval(check);
          }
        }, 300);
      }
    }
  }
}

function collectionRandomLimitedEditionPrints(){
  if ($('.collection-random-limited-edition-prints').length > 0) {
    var collection = [];
    $('.collection-random-limited-edition-prints li').each(function(){
      var id = $(this).data('id');
      collection.push(id);
    });
    console.log(collection);
    var all_size = $('.collection-random-limited-edition-prints li').length,
        limit = $('.collection-random-limited-edition-prints').data('limit');
    if (all_size > limit) {
      size = limit;
    } else {
      size = all_size;
    }
    var random_index = [];
    while(random_index.length < size){
      var key = collection[Math.floor(Math.random()*collection.length)];
     console.log(key);
      if( random_index.indexOf(key) == -1 ) {
        random_index.push(key);
        var collectionImg = $('.collection-random-limited-edition-prints li[data-id="' +key+ '"]').data('img'),
            collectionHandle = $('.collection-random-limited-edition-prints li[data-id="' +key+ '"]').data('handle'),
            collectionTitle = $('.collection-random-limited-edition-prints li[data-id="' +key+ '"]').data('title'),
            collectionPrice = $('.collection-random-limited-edition-prints li[data-id="' +key+ '"]').data('price');
            var $priceElement = $(collectionPrice);
            var extractedText = $priceElement.text();
            collectionsessionPrice = $('.collection-random-limited-edition-prints li[data-id="' +key+ '"]').data('session-price');
            collectionavailable = $('.collection-random-limited-edition-prints li[data-id="' +key+ '"]').data('available');

        
        var html = '';
        html +=  '<div class="grid__item item">';
            html +=  '<div class="equalHeights__random"><a href="/collections/limited-edition-giclee-prints/products/' +collectionHandle+ '"><img class="lazyload test8 custom-height"  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-expand="600" data-src="'+collectionImg+'" alt="'+collectionTitle+'" /></a></div>';
            html +=  '<h5><a href="/collections/limited-edition-giclee-prints/products/' +collectionHandle+ '">'+collectionTitle+'</a></h5>';
          if(collectionavailable != false){
          html +=  '<p class="mlmoney"><span>'+extractedText+'</span></p>';
          html += '<p class="grid-link__meta custmoney">'+collectionsessionPrice+'<span class="hideaud" style="display: none;"> + GST</span></p>';
          }
          else{
          html += '<p class="grid-link__meta m-t-5"><span class="red_circle"></span></p>';
          }
        html +=  '</div>';
        $('.collection-random-limited-edition-prints').append(html);
      }
    }
    if ($('body').hasClass('template-index')) {
      var check = setInterval(function(){
        if (random_index.length >= size) {
          $('.equalHeights__random').css('height', 'auto').equalHeights();
          clearInterval(check);
        }
      }, 300);
    } else {
      if ( window.innerWidth < 831 ) {
        var check = setInterval(function(){
          if (random_index.length >= size) {
            $('.equalHeights__random').css('height', 'auto').equalHeights();
            clearInterval(check);
          }
        }, 300);
      }
    }
  }
}

function collectionRandomShaunTanLimitedEditionPrints(){
    if ($('.collection-random-shaun-tans-limited-edition-prints').length > 0) {
    var collection = [];
    $('.collection-random-shaun-tans-limited-edition-prints li').each(function(){
      var id = $(this).data('id');
      collection.push(id);
    });
    console.log(collection);
    var all_size = $('.collection-random-shaun-tans-limited-edition-prints li').length,
        limit = $('.collection-random-shaun-tans-limited-edition-prints').data('limit');
    if (all_size > limit) {
      size = limit;
    } else {
      size = all_size;
    }
    var random_index = [];
    while(random_index.length < size){
      var key = collection[Math.floor(Math.random()*collection.length)];
     console.log(key);
      if( random_index.indexOf(key) == -1 ) {
        random_index.push(key);
        var collectionImg = $('.collection-random-shaun-tans-limited-edition-prints li[data-id="' +key+ '"]').data('img'),
            collectionHandle = $('.collection-random-shaun-tans-limited-edition-prints li[data-id="' +key+ '"]').data('handle'),
            collectionTitle = $('.collection-random-shaun-tans-limited-edition-prints li[data-id="' +key+ '"]').data('title'),
            collectionPrice = $('.collection-random-shaun-tans-limited-edition-prints li[data-id="' +key+ '"]').data('price');
            var $priceElement = $(collectionPrice);
            var extractedText = $priceElement.text();
            collectionsessionPrice = $('.collection-random-shaun-tans-limited-edition-prints li[data-id="' +key+ '"]').data('session-price');
            collectionavailable = $('.collection-random-shaun-tans-limited-edition-prints li[data-id="' +key+ '"]').data('available');

        
        var html = '';
        html +=  '<div class="grid__item item">';
            html +=  '<div class="equalHeights__random"><a href="/collections/shaun-tan-limited-edition-prints/products/' +collectionHandle+ '"><img class="lazyload test8 custom-height"  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-expand="600" data-src="'+collectionImg+'" alt="'+collectionTitle+'" /></a></div>';
            html +=  '<h5><a href="/collections/shaun-tan-limited-edition-prints/products/' +collectionHandle+ '">'+collectionTitle+'</a></h5>';
          if(collectionavailable != false){
          html +=  '<p class="mlmoney"><span>'+extractedText+'</span></p>';
          html += '<p class="grid-link__meta custmoney">'+collectionsessionPrice+'<span class="hideaud" style="display: none;"> + GST</span></p>';
          }
          else{
          html += '<p class="grid-link__meta m-t-5"><span class="red_circle"></span></p>';
          }
        html +=  '</div>';
        $('.collection-random-shaun-tans-limited-edition-prints').append(html);
      }
    }
    if ($('body').hasClass('template-index')) {
      var check = setInterval(function(){
        if (random_index.length >= size) {
          $('.equalHeights__random').css('height', 'auto').equalHeights();
          clearInterval(check);
        }
      }, 300);
    } else {
      if ( window.innerWidth < 831 ) {
        var check = setInterval(function(){
          if (random_index.length >= size) {
            $('.equalHeights__random').css('height', 'auto').equalHeights();
            clearInterval(check);
          }
        }, 300);
      }
    }
  }
}

function productRandom() {
  if ($('.product-random-js').length > 0) {
    $('.product-random-js').each(function(){
      var id = '#' + $(this).parents('.product-random-section').attr('id'),
          data = $(this).data('collection'),
          url_collection = '/collections/' + data + '/products.json?limit=2090',
          limit = $(this).data('limit');
          console.log(url_collection);
      $.ajax({
        url: url_collection,
        type: 'get',
        dataType: 'json',
        success: function (result){
          var random_index = [],
              totalProduct = result['products'].length;
          if (limit > totalProduct) {
            size = totalProduct;
          } else {
            size = limit;
          }
          while(random_index.length < size){
              var key = Math.floor(Math.random()*result['products'].length);
              if( random_index.indexOf(key) == -1 )
              {
                  random_index.push(key);
              }
          }
          var html = '';

          $.each(result['products'], function (key, item){
              if(random_index.indexOf(key) != -1){
                  html +=  '<div class="grid__item item">';
                      html +=  '<div class="equalHeights__product"><a href="/products/' +item['handle']+ '"><img class="lazyload test10"data-src="'+item['images'][0]['src']+'" alt="" /></a></div>';
                      html +=  '<h5><a href="/products/' +item['handle']+ '">'+item['title']+'</a></h5>';
                      html +=  '<p class="mlmoney"><span>$'+parseFloat(item['variants'][0]['price'])+' AUD</span></p>';
                      html +=  '<p class="custmoney"><span class="money">$'+parseFloat(item['variants'][0]['price'])+' AUD</span></p>';
                  html +=  '</div>';
              }
          });
          $(id+' .product-random-js').html(html);
          var check = setInterval(function(){
            if (random_index.length >= size) {
              $('.equalHeights__product').css('height', 'auto').equalHeights();
              clearInterval(check);
            }
          }, 300);
        }
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Replace 'COLLECTION_ID' with the actual collection ID you want to fetch
  const collectionId = '264427274339';
url_collection = '/collections/' + collectionId + '/products.json?limit=2090',
      console.log(url_collection);
      $.ajax({
        url: url_collection,
        type: 'get',
        dataType: 'json',
        success: function (result){
          console.log(result);
          // var random_index = [],
          //     totalProduct = result['products'].length;
          // if (limit > totalProduct) {
          //   size = totalProduct;
          // } else {
          //   size = limit;
          // }
          // while(random_index.length < size){
          //     var key = Math.floor(Math.random()*result['products'].length);
          //     if( random_index.indexOf(key) == -1 )
          //     {
          //         random_index.push(key);
          //     }
          // }
          // var html = '';

          // $.each(result['products'], function (key, item){
          //     if(random_index.indexOf(key) != -1){
          //         html +=  '<div class="grid__item item">';
          //             html +=  '<div class="equalHeights__product"><a href="/products/' +item['handle']+ '"><img class="lazyload test10"data-src="'+item['images'][0]['src']+'" alt="" /></a></div>';
          //             html +=  '<h5><a href="/products/' +item['handle']+ '">'+item['title']+'</a></h5>';
          //             html +=  '<p class="mlmoney"><span>$'+parseFloat(item['variants'][0]['price'])+' AUD</span></p>';
          //             html +=  '<p class="custmoney"><span class="money">$'+parseFloat(item['variants'][0]['price'])+' AUD</span></p>';
          //         html +=  '</div>';
          //     }
          // });
          // $(id+' .product-random-js').html(html);
          // var check = setInterval(function(){
          //   if (random_index.length >= size) {
          //     $('.equalHeights__product').css('height', 'auto').equalHeights();
          //     clearInterval(check);
          //   }
          // }, 300);
        }
      });
});




/*$(document).ready(function() {
  var elementId = 'shopify-section-9024c5ed-6c49-494c-ad1b-95505a6bb96d';
  $('#' + elementId).removeClass('index-section--product');
});*/

/*jQuery(document).ready(function(){
	jQuery(document).on("click",".read_more",function(){
      console.log('read_more');
		//jQuery(".second_section").hide();
		jQuery(this).prev('span').show();
      	jQuery(this).removeClass("read_more");
		jQuery(this).addClass("readless");
		jQuery(this).text("Read Less");
    });
	jQuery(document).on("click",".readless",function(){
		//jQuery(".second_section").hide();
      console.log('readless');
		jQuery(this).prev('span').hide();
      	jQuery(this).removeClass("readless");
		jQuery(this).addClass("read_more");
		jQuery(this).text("Read More");
    });
});*/